import { render, staticRenderFns } from "./FulfillmentResumeRow.vue?vue&type=template&id=99164c22&"
import script from "./FulfillmentResumeRow.vue?vue&type=script&lang=js&"
export * from "./FulfillmentResumeRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports